import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" style={{ borderTop: '0.5px solid var(--iab-border)', background: 'var(--iab-cream)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Logo & tagline */}
          <div>
            <Link to="/" className="flex items-baseline gap-0 select-none" style={{ fontFamily: 'var(--genz-font-display)', fontSize: 'var(--iab-text-lg)', fontWeight: 700, letterSpacing: '-0.02em' }}>
              <span style={{ color: '#16130F' }}>iam</span>
              <span style={{ color: '#C17F24' }}>because</span>
            </Link>
            <p className="mt-2 max-w-xs" style={{ fontSize: 'var(--iab-text-sm)', color: 'var(--iab-charcoal-soft)' }}>
              a collection of human stories. no ads. no algorithms. just why.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col md:flex-row gap-6 md:gap-8">
            <div className="flex gap-6" style={{ fontSize: 'var(--iab-text-sm)', color: 'var(--iab-charcoal-soft)' }}>
              <Link to="/" className="hover:opacity-80 transition-opacity">the whys</Link>
              <Link to="/icons" className="hover:opacity-80 transition-opacity">icons</Link>
              <Link to="/submit" className="hover:opacity-80 transition-opacity">share your why</Link>
              <Link to="/about" className="hover:opacity-80 transition-opacity">about</Link>
              <Link to="/insights" className="hover:opacity-80 transition-opacity">insights</Link>
            </div>
            <div className="flex gap-6" style={{ fontSize: 'var(--iab-text-sm)', color: 'var(--iab-charcoal-pale)' }}>
              <Link to="/privacy" className="hover:opacity-80 transition-opacity">privacy</Link>
              <Link to="/terms" className="hover:opacity-80 transition-opacity">terms</Link>
              <Link to="/guidelines" className="hover:opacity-80 transition-opacity">guidelines</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 flex flex-col items-center gap-4" style={{ borderTop: '0.5px solid var(--iab-border)' }}>
          <button
            data-testid="footer-talk-to-mira"
            onClick={() => {
              const orb = document.querySelector('[data-testid="mira-orb"]');
              if (orb) orb.click();
            }}
            className="brutal-btn inline-flex items-center gap-2 px-6 py-2.5 text-sm"
            style={{ background: '#E91E8C', color: '#fff' }}
          >
            talk it out with mira &rarr;
          </button>
          <p style={{ fontFamily: "var(--genz-font-hand)", fontSize: '16px', color: '#888780' }}>
            mira listens. mira asks. mira remembers.
          </p>
          <div className="flex items-center gap-1.5 mt-2" style={{ fontSize: 'var(--iab-text-xs)', color: 'var(--iab-charcoal-pale)' }}>
            <span>made with</span>
            <Heart size={12} style={{ color: 'var(--iab-amber)', fill: 'var(--iab-amber)' }} />
            <span>for the humans who show up</span>
          </div>
        </div>

        <p className="mt-6 text-center max-w-2xl mx-auto leading-relaxed" style={{ fontSize: '11px', color: 'var(--iab-charcoal-pale)' }}>
          All stories on iambecause are shared voluntarily by their authors and published with their consent. Stories reflect the personal views and experiences of the individuals who wrote them and do not represent the views of iambecause, Les Concierges&reg;, or any associated organisation. To request removal of your story write to hello@iambecause.com — we will act within 48 hours, no questions asked.
        </p>
      </div>
    </footer>
  );
}
